import { LoadingStageModel } from '@kts-front/models';
import { Alert } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import EmptyStub from 'components/ui/EmptyStub';
import Loader from 'components/ui/Loader';

type Props = {
  loadingStage: LoadingStageModel;
  isEmpty: boolean;
  className?: string;
  isLoaderAfterChildren?: boolean;
};

type Options = {
  ComponentEmpty?: React.FC<{ className?: string }>;
  ComponentLoader?: React.FC<{ className?: string }>;
};

export type withAsyncContentProps<P extends Record<any, any>> = P & Props;

export const withAsyncContent = <P extends Record<any, any>>(
  WrappedComponent: React.ComponentType<Omit<P, keyof Props>>,
  options?: Options,
): React.ComponentType<withAsyncContentProps<P>> =>
  observer(({ className, loadingStage, isEmpty, isLoaderAfterChildren, ...props }) => {
    const ComponentEmpty = options?.ComponentEmpty ?? EmptyStub;
    const ComponentLoader = options?.ComponentLoader ?? Loader;

    if (!isLoaderAfterChildren && (loadingStage.isNotStarted || loadingStage.isLoading)) {
      return <ComponentLoader className={className} fullHeight />;
    }

    if (loadingStage.isError) {
      return (
        <Alert className={className} color="red" variant="light">
          Произошла ошибка, попробуйте повторить позже
        </Alert>
      );
    }

    if (isEmpty && loadingStage.isSuccess) {
      return <ComponentEmpty title="Список пуст" className={className} fullHeight />;
    }

    return (
      <>
        <WrappedComponent {...props} />
        {isLoaderAfterChildren && (loadingStage.isNotStarted || loadingStage.isLoading) && <ComponentLoader />}
      </>
    );
  });
